import { defineComponent as $, computed as k, createElementBlock as a, createCommentVNode as w, openBlock as r, createElementVNode as i, normalizeClass as f, createTextVNode as pe, toDisplayString as I, normalizeStyle as H, createBlock as R, renderSlot as D, mergeProps as G, unref as h, mergeModels as we, useModel as se, ref as E, Fragment as z, renderList as P, watch as fe, createVNode as K, toRefs as me, withDirectives as he, withCtx as W, normalizeProps as $e, guardReactiveProps as _e, getCurrentInstance as Ve, createSlots as ve, useTemplateRef as U, onMounted as ae, useAttrs as Te, onUnmounted as Ae, inject as Ce, TransitionGroup as Ie } from "vue";
import N from "dayjs";
import Be from "dayjs/plugin/isSameOrAfter";
import Le from "dayjs/plugin/isSameOrBefore";
import { v4 as ne } from "uuid";
const Se = {
  key: 0,
  class: "h-24px w-24px flex items-center justify-center"
}, Ee = { class: "content-10-h16-b text-white tracking-0" }, Me = { key: 0 }, ll = /* @__PURE__ */ $({
  __name: "AuBadge",
  props: {
    count: {}
  },
  setup(l) {
    const e = l, t = k(() => e.count > 99);
    return (o, s) => o.count > 0 ? (r(), a("div", Se, [
      i("div", {
        class: f(["h-16px flex items-center justify-center rounded-full bg-brand-blush-pink", t.value ? "w-24px" : "w-16px"])
      }, [
        i("p", Ee, [
          pe(I(t.value ? 99 : o.count), 1),
          t.value ? (r(), a("span", Me, "+")) : w("", !0)
        ])
      ], 2)
    ])) : w("", !0);
  }
}), De = ["height", "width"], je = /* @__PURE__ */ $({
  __name: "LoadingSpinner",
  props: {
    isCtaType: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    size: { default: 30 }
  },
  setup(l) {
    const e = l;
    return (t, o) => t.isLoading ? (r(), a("div", {
      key: 0,
      style: H({
        width: `${t.size}px`,
        height: `${t.size}px`
      })
    }, [
      (r(), a("svg", {
        height: e.size,
        viewBox: "10 10 100 100",
        width: e.size
      }, [
        i("path", {
          class: f(["background-arc", t.isCtaType ? "fill-light-gray" : "fill-primary-10"]),
          d: `M60,92.4c17.9,0,32.4-14.5,32.4-32.4S77.9,27.6,60,27.6S27.6,42.1,27.6,60S42.1,92.4,60,92.4z M60,96
	c19.9,0,36-16.1,36-36c0-19.9-16.1-36-36-36c-19.9,0-36,16.1-36,36C24,79.9,40.1,96,60,96z`
        }, null, 2),
        i("path", {
          class: f(["colored-arc", t.isCtaType ? "stroke-primary-80" : "stroke-brand-deep-yellow"]),
          d: "M60,25.8c0,0,14.6-1,25.2,11.1c10.6,12.1,9,25.3,9,25.3"
        }, null, 2)
      ], 8, De))
    ], 4)) : w("", !0);
  }
}), J = (l, e) => {
  const t = l.__vccOpts || l;
  for (const [o, s] of e)
    t[o] = s;
  return t;
}, qe = /* @__PURE__ */ J(je, [["__scopeId", "data-v-d08b3549"]]), Ne = ["disabled"], ze = { class: "w-fit truncate" }, Pe = /* @__PURE__ */ $({
  __name: "AuButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    iconName: { default: "" },
    iconRight: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    structure: { default: "text" },
    type: { default: "bg-border" }
  },
  setup(l) {
    const e = l, t = k(() => e.loading || e.structure === "loading");
    return (o, s) => (r(), a("button", {
      class: f(["hover:shadow-btn-shadow relative box-border h-40px flex flex-shrink-0 cursor-pointer items-center justify-center border-1 rounded-full border-solid px-23px title-12-h16-m disabled:opacity-30", [
        `button-${o.type}`,
        {
          "pointer-events-none": o.disabled || t.value,
          "w-84px": o.structure === "loading"
        }
      ]]),
      disabled: e.disabled,
      type: "button"
    }, [
      t.value ? (r(), R(qe, {
        key: 0,
        class: "absolute",
        "is-cta-type": "",
        "is-loading": "",
        size: 36
      })) : w("", !0),
      i("div", {
        class: f(["h-full w-full flex items-center justify-center gap-x-4px", {
          "flex-row-reverse": o.iconRight,
          invisible: t.value
        }])
      }, [
        o.iconName !== "" ? (r(), a("i", {
          key: 0,
          class: f(["text-24px", `icon-${o.iconName}`])
        }, null, 2)) : w("", !0),
        i("div", ze, [
          D(o.$slots, "default", {}, void 0, !0)
        ])
      ], 2)
    ], 10, Ne));
  }
}), ol = /* @__PURE__ */ J(Pe, [["__scopeId", "data-v-cd483e19"]]);
function Z(l) {
  return {
    ...l,
    class: ""
  };
}
const He = ["checked", "disabled", "required"], Oe = {
  key: 1,
  class: "self-start text-red"
}, Ue = {
  key: 2,
  class: "ml-auto content-10-h12-r text-primary-40"
}, Re = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "AuCheckbox",
  props: {
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    fontType: { default: "text" },
    modelValue: { type: Boolean },
    multiLine: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(l) {
    const e = l;
    return (t, o) => (r(), a("label", {
      class: f(["relative my-4px flex cursor-pointer gap-4px px-4px text-primary-80 hover:text-primary-50", [
        t.$attrs.class,
        {
          "error text-red": t.error,
          "content-12-h16-r": t.fontType === "text",
          "title-12-h16-m": t.fontType === "title",
          "items-start": t.multiLine,
          "items-center": !t.multiLine
        }
      ]])
    }, [
      i("input", G(h(Z)(t.$attrs), {
        checked: t.modelValue,
        class: "absolute h-0 w-0 cursor-pointer opacity-0",
        disabled: e.disabled,
        required: e.required,
        role: "checkbox",
        tabindex: "0",
        type: "checkbox",
        onChange: o[0] || (o[0] = (s) => t.$emit("update:modelValue", !t.modelValue))
      }), null, 16, He),
      t.$slots.default ? (r(), a("span", {
        key: 0,
        class: f(["ml-8px", { "flex-shrink truncate": !t.multiLine }])
      }, [
        D(t.$slots, "default", {}, void 0, !0)
      ], 2)) : w("", !0),
      t.required ? (r(), a("span", Oe, "*")) : w("", !0),
      t.$slots.description ? (r(), a("span", Ue, [
        D(t.$slots, "description", {}, void 0, !0)
      ])) : w("", !0)
    ], 2));
  }
}), We = /* @__PURE__ */ J(Re, [["__scopeId", "data-v-82a3b16b"]]), Ye = {
  key: 0,
  class: "w-full flex gap-4px content-11-h16-r"
}, Fe = ["for"], Ke = {
  key: 0,
  class: "text-red"
}, Ge = { class: "relative w-full flex items-center" }, Je = ["onClick"], Xe = ["id", "disabled", "placeholder", "readonly", "required", "value"], Qe = ["onClick"], Ze = {
  key: 1,
  class: "box-border w-full flex gap-4px px-16px content-10-h12-r"
}, et = ["href"], Y = 16, F = 24, Q = 4, ee = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "AuInput",
  props: /* @__PURE__ */ we({
    assistiveText: { default: "" },
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    id: { default: ne() },
    label: { default: "" },
    leftIcons: { default: () => [] },
    linkDescribe: { default: "" },
    linkPath: { default: "" },
    noLinkUnderline: { type: Boolean, default: !1 },
    placeholder: { default: "" },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    rightIcons: { default: () => [] }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {},
    checkboxValue: { type: [Boolean, null], default: null },
    checkboxValueModifiers: {}
  }),
  emits: ["update:modelValue", "update:checkboxValue"],
  setup(l) {
    const e = l, t = se(l, "modelValue"), o = se(l, "checkboxValue"), s = E(!1);
    function p(u) {
      if (!(u.target instanceof HTMLInputElement))
        throw new Error("only accept HTMLInputElement");
      t.value = u.target.value;
    }
    const c = k(
      () => Y + e.leftIcons.length * (F + Q)
    ), d = k(
      () => Y + e.rightIcons.length * (F + Q)
    ), n = k(() => e.disabled ? "text-primary-50 placeholder-primary-50 border-primary-10 bg-green-60-5" : e.error ? "text-red placeholder-red border-red bg-white" : "text-primary-80 placeholder-primary-50 border-primary-30 bg-white focus:border-primary-50"), v = k(() => e.disabled ? "text-primary-40" : e.error ? "text-red" : "text-primary-50");
    function m(u, _) {
      u !== void 0 && u(_);
    }
    return (u, _) => (r(), a("div", {
      class: f(["flex flex-col items-start gap-4px", [
        u.$attrs.class,
        {
          "pointer-events-none": e.disabled
        }
      ]])
    }, [
      e.label !== "" ? (r(), a("div", Ye, [
        i("label", {
          class: "ml-4px block flex-shrink truncate text-primary-80",
          for: e.id
        }, I(e.label), 9, Fe),
        e.required ? (r(), a("span", Ke, "*")) : w("", !0)
      ])) : w("", !0),
      i("div", Ge, [
        (r(!0), a(z, null, P(e.leftIcons, ({ iconName: B, click: L }, V) => (r(), a("i", {
          key: V,
          class: f(["absolute mr-8px text-24px", [
            `icon-${B}`,
            v.value,
            {
              "cursor-pointer": L !== void 0,
              "pointer-events-none": L === void 0
            }
          ]]),
          style: H({
            left: `${Y + (F + Q) * V}px`
          }),
          onClick: (S) => m(L, S)
        }, null, 14, Je))), 128)),
        i("input", G(h(Z)(u.$attrs), {
          id: e.id,
          class: ["box-border h-40px w-full cursor-inherit truncate border-1 rounded-full border-solid py-8px content-12-h24-r outline-none", n.value],
          disabled: e.disabled,
          placeholder: e.placeholder,
          readonly: e.readonly,
          required: e.required,
          style: {
            "padding-left": `${c.value}px`,
            "padding-right": `${d.value}px`
          },
          value: t.value,
          onBlur: _[0] || (_[0] = (B) => s.value = !1),
          onFocus: _[1] || (_[1] = (B) => s.value = !0),
          onInput: p
        }), null, 16, Xe),
        (r(!0), a(z, null, P(e.rightIcons, ({ iconName: B, click: L }, V) => (r(), a("i", {
          key: V,
          class: f(["peer absolute ml-4px cursor-pointer text-24px", [
            `icon-${B}`,
            v.value,
            {
              "cursor-pointer": L !== void 0,
              "pointer-events-none": L === void 0 && !u.$slots.tooltip
            }
          ]]),
          style: H({
            right: `${Y + (F + Q) * V}px`
          }),
          onClick: (S) => m(L, S)
        }, null, 14, Qe))), 128)),
        u.$slots.tooltip ? (r(), a("div", {
          key: 0,
          class: "invisible absolute bottom-34px z-10 max-w-200px translate-x-1/2 break-words rounded-5px bg-transparent-70 p-4px content-10-h12-r text-white peer-hover:visible",
          style: H({ right: `${F / 2 + Y}px` })
        }, [
          D(u.$slots, "tooltip")
        ], 4)) : w("", !0)
      ]),
      o.value !== null || e.assistiveText !== "" || e.linkPath !== "" ? (r(), a("div", Ze, [
        i("label", {
          class: f(["flex flex-grow gap-4px", {
            "cursor-pointer": o.value !== null
          }])
        }, [
          o.value !== null ? (r(), R(We, {
            key: 0,
            modelValue: o.value,
            "onUpdate:modelValue": _[2] || (_[2] = (B) => o.value = B),
            class: "p-0",
            disabled: e.disabled
          }, null, 8, ["modelValue", "disabled"])) : w("", !0),
          i("span", {
            class: f(["m-0 flex flex-grow items-center content-10-h12-r", {
              "text-primary-40": !e.error || e.error && e.disabled,
              "text-red": e.error && !e.disabled
            }])
          }, I(e.assistiveText), 3)
        ], 2),
        e.linkPath !== "" && e.linkDescribe !== "" ? (r(), a("a", {
          key: 0,
          class: f({ "no-underline": u.noLinkUnderline }),
          href: e.linkPath,
          rel: "noopener noreferrer",
          target: "_blank"
        }, I(e.linkDescribe), 11, et)) : w("", !0)
      ])) : w("", !0)
    ], 2));
  }
}), tt = {
  key: 0,
  class: "absolute z-1 box-border w-296px rounded-10px bg-white p-8px text-primary-80 shadow-calendar"
}, lt = { class: "h-40px flex items-center justify-between px-4px" }, ot = {
  key: 0,
  class: "h-20px w-56px flex gap-16px"
}, rt = {
  key: 0,
  class: "h-224px overflow-x-hidden overflow-y-scroll"
}, at = {
  key: 0,
  class: "flex flex-wrap items-center justify-center gap-x-8px gap-y-16px"
}, nt = ["onClick"], st = {
  key: 1,
  class: "flex flex-wrap items-center justify-center gap-16px"
}, it = ["onClick"], ut = { key: 1 }, dt = { class: "box-border h-44px flex border-b-1px border-primary-30 border-b-solid" }, ct = { class: "flex flex-wrap items-center justify-start" }, pt = ["onClick"], ie = "YYYY/MM/DD", ue = 2020, de = 2100, rl = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "AuCalendar",
  props: {
    disabled: { type: Boolean, default: !1 },
    endDate: { default: "" },
    error: { type: Boolean, default: !1 },
    label: { default: "" },
    modelValue: { default: () => (/* @__PURE__ */ new Date()).toDateString() },
    placeholder: { default: "" },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    startDate: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    N.extend(Le), N.extend(Be);
    const t = l, o = e, s = ["S", "M", "T", "W", "T", "F", "S"], p = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function c(g, C) {
      const y = [];
      for (let A = g; A <= C; A++)
        y.push(A);
      return y;
    }
    const d = c(ue, de), n = E(null);
    fe(
      () => t.disabled,
      () => {
        n.value = null;
      }
    );
    function v() {
      if (n.value === null) {
        const g = N(t.modelValue === "" ? /* @__PURE__ */ new Date() : t.modelValue);
        m.value = g.isValid() ? g : N(), n.value = "date";
      } else
        n.value = null;
    }
    const m = E(N()), u = E(""), _ = k(() => m.value.year()), B = k(() => m.value.month() + 1), L = k(() => m.value.date()), V = k(
      () => N(t.startDate === "" ? `${ue}/01/01` : t.startDate)
    ), S = k(
      () => N(t.endDate === "" ? `${de}/12/31` : t.endDate)
    ), j = k(
      () => m.value.isSameOrAfter(V.value, "month")
    ), O = k(
      () => m.value.isSameOrBefore(S.value, "month")
    );
    function b(g) {
      return g.isSame(N(), "day");
    }
    function x(g) {
      return [0, 6].includes(g.day());
    }
    function T(g, C) {
      return g.isAfter(S.value, C) || g.isBefore(V.value, C);
    }
    function M(g, C) {
      T(V.value, "date") || (q(g), C == null || C());
    }
    function q(g) {
      g.isSameOrBefore(V.value) ? g = V.value : g.isSameOrAfter(S.value) && (g = S.value), m.value = g.isValid() ? g : N(), u.value = m.value.format(ie), o("update:modelValue", m.value.format(ie));
    }
    function X(g) {
      var A;
      u.value = g.replace(/[^\d/]/g, "").substring(0, 10), u.value = u.value.replace(/\/{2}/g, "/"), /^\d{5}/.test(u.value) && (u.value = `${u.value.substring(0, 4)}/${u.value.substring(4)}`), /^\d{4}\/\d{3}/.test(u.value) && (u.value = `${u.value.substring(0, 7)}/${u.value.substring(7)}`);
      const C = /^(?<year>\d{4})\/(?<month>\d{1,2})\/(?<day>\d{1,2})$/;
      if (!C.test(u.value))
        return;
      const { day: y } = ((A = C.exec(u.value)) == null ? void 0 : A.groups) ?? {};
      y === void 0 || y.length === 1 && Number.parseInt(y) < 4 || (q(N(u.value)), n.value = "date");
    }
    function le(g) {
      g.key === "Enter" && q(N(u.value));
    }
    return (g, C) => (r(), a("div", {
      class: f(["relative", [
        {
          "pointer-events-none": g.disabled
        },
        g.$attrs.class
      ]])
    }, [
      K(ee, G(g.$attrs, {
        class: "cursor-pointer",
        disabled: t.disabled,
        error: t.error,
        label: t.label,
        "model-value": u.value,
        placeholder: t.placeholder,
        readonly: t.readonly,
        required: t.required,
        "right-icons": [{ iconName: "calendar" }],
        onClick: v,
        onKeyup: le,
        "onUpdate:modelValue": X
      }), null, 16, ["disabled", "error", "label", "model-value", "placeholder", "readonly", "required"]),
      n.value !== null ? (r(), a("div", tt, [
        i("div", lt, [
          i("div", {
            class: "flex cursor-pointer gap-4px",
            onClick: C[0] || (C[0] = (y) => n.value = n.value === "year" ? "month" : "year")
          }, [
            pe(I(m.value.format("MMMM YYYY")) + " ", 1),
            i("i", {
              class: f(["text-20px", {
                "icon-down-fill icon-arrow-down": n.value === "date",
                "icon-up-fill icon-arrow-up": n.value !== "date"
              }])
            }, null, 2)
          ]),
          n.value == "date" ? (r(), a("div", ot, [
            i("i", {
              class: f(["icon-chevron-left text-20px", {
                "text-primary-30": !j.value,
                "cursor-pointer": j.value
              }]),
              onClick: C[1] || (C[1] = (y) => M(m.value.subtract(1, "month")))
            }, null, 2),
            i("i", {
              class: f(["icon-chevron-right text-20px", {
                "text-primary-30": !O.value,
                "cursor-pointer": O.value
              }]),
              onClick: C[2] || (C[2] = (y) => M(m.value.add(1, "month")))
            }, null, 2)
          ])) : w("", !0)
        ]),
        ["year", "month"].includes(n.value) ? (r(), a("div", rt, [
          n.value === "year" ? (r(), a("div", at, [
            (r(!0), a(z, null, P(h(d), (y, A) => (r(), a("div", {
              key: A,
              class: f(["h-40px w-83px flex cursor-pointer items-center justify-center", {
                "rounded-full bg-brand-deep-yellow": y === _.value,
                "text-primary-30 pointer-events-none": V.value.year() > y || S.value.year() < y
              }]),
              onClick: () => {
                q(m.value.year(y)), n.value = "month";
              }
            }, I(y), 11, nt))), 128))
          ])) : (r(), a("div", st, [
            (r(), a(z, null, P(p, (y, A) => i("div", {
              key: A,
              class: f(["h-40px w-76px flex cursor-pointer items-center justify-center", {
                "rounded-full bg-brand-deep-yellow": A === B.value - 1,
                "text-primary-30 pointer-events-none": T(
                  m.value.month(A),
                  "month"
                )
              }]),
              onClick: () => {
                q(m.value.month(A)), n.value = "date";
              }
            }, I(y), 11, it)), 64))
          ]))
        ])) : n.value === "date" ? (r(), a("div", ut, [
          i("div", dt, [
            (r(), a(z, null, P(s, (y, A) => i("div", {
              key: A,
              class: f(["h-full w-40px flex items-center justify-center", {
                "text-red": y === "S"
              }])
            }, I(y), 3)), 64))
          ]),
          i("div", ct, [
            (r(!0), a(z, null, P(c(1, m.value.set("date", 1).day()), (y, A) => (r(), a("div", {
              key: A,
              class: "h-44px w-40px"
            }))), 128)),
            (r(!0), a(z, null, P(c(1, m.value.daysInMonth()), (y, A) => (r(), a("div", {
              key: A,
              class: f(["h-40px w-40px flex cursor-pointer items-center justify-center", {
                "bg-brand-deep-yellow rounded-full": y === L.value,
                "bg-primary-30 rounded-full": b(m.value.date(y)) && y !== L.value,
                "text-red": x(m.value.set("date", y)),
                "text-primary-30 pointer-events-none": T(m.value.date(y), "date") && !x(m.value.set("date", y)),
                "opacity-30 pointer-events-none": T(m.value.date(y), "date") && x(m.value.set("date", y))
              }]),
              onClick: (Jt) => M(m.value.date(y), () => {
                n.value = null;
              })
            }, I(y), 11, pt))), 128))
          ])
        ])) : w("", !0)
      ])) : w("", !0)
    ], 2));
  }
}), al = /* @__PURE__ */ $({
  __name: "AuColorDisplay",
  props: {
    colorType: {},
    value: {}
  },
  setup(l) {
    return (e, t) => (r(), a("div", {
      class: "h-24px w-24px border-1px border-primary-40 rounded-full bg-cover",
      style: H({
        "background-color": e.colorType === "HexCode" ? e.value : "",
        "background-image": e.colorType === "ImgUrl" ? `url(${e.value})` : ""
      })
    }, null, 4));
  }
}), ft = ["transparent", "none"];
function be(l) {
  return typeof l == "string" && /^#(?:[\dA-F]{3}|[\dA-F]{6})$/i.test(l);
}
function ye(l) {
  return typeof l == "string" && ft.includes(l);
}
function ce(l) {
  return l.startsWith("https://") && !ye(l) && !be(l);
}
const mt = /* @__PURE__ */ $({
  __name: "AuRoundImage",
  props: {
    color: {},
    size: { default: 21 }
  },
  setup(l) {
    const e = l, { color: t, size: o } = me(e);
    return (s, p) => (r(), a("span", {
      class: f(["box-border flex-shrink-0 border-1px border-primary-40 rounded-full border-solid", {
        [h(t)]: h(ye)(h(t)),
        "bg-contain": h(ce)(h(t))
      }]),
      style: H({
        "background-image": h(ce)(h(t)) ? `url(${h(t)})` : "",
        "background-color": h(be)(h(t)) ? h(t) : "",
        width: `${h(o)}px`,
        height: `${h(o)}px`
      })
    }, null, 6));
  }
}), ht = /* @__PURE__ */ J(mt, [["__scopeId", "data-v-230ecf26"]]), nl = /* @__PURE__ */ $({
  __name: "AuColorPicker",
  props: {
    color: {},
    handle: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(l) {
    return (e, t) => (r(), a("div", {
      class: f(["box-border h-32px w-32px flex cursor-pointer items-center justify-center border-1 rounded-full border-solid", {
        "hover:border-primary-20 border-transparent": e.handle !== e.modelValue,
        "border-primary-100": e.handle === e.modelValue
      }]),
      onClick: t[0] || (t[0] = (o) => e.$emit("update:modelValue", e.handle))
    }, [
      K(ht, {
        color: e.color,
        size: 28
      }, null, 8, ["color"])
    ], 2));
  }
}), oe = /* @__PURE__ */ new Map();
document.addEventListener(
  "click",
  (l) => {
    const e = l.composedPath();
    for (const [t, o] of oe.entries())
      e.includes(t) || o();
  },
  {
    capture: !0
    // 在捕獲階段處理，確保在子元素移除前判斷
  }
);
const xe = {
  mounted(l, e) {
    if (typeof e.value != "function") {
      console.warn("[v-click-outside]: binding value must be a function.");
      return;
    }
    oe.set(l, e.value);
  },
  unmounted(l) {
    oe.delete(l);
  }
}, vt = ["onClick"], bt = { class: "truncate" }, ge = /* @__PURE__ */ $({
  __name: "AuList",
  props: {
    list: {},
    maxHeight: {},
    modelValue: {},
    visible: { type: Boolean }
  },
  emits: ["update:modelValue", "update:visible"],
  setup(l, { emit: e }) {
    const t = l, o = k(() => typeof t.maxHeight == "number" ? { maxHeight: `${t.maxHeight}px` } : void 0);
    function s(d, n) {
      n == null || n.preventDefault(), c("update:modelValue", d.key), p();
    }
    function p() {
      c("update:visible", !1);
    }
    const c = e;
    return (d, n) => d.visible ? (r(), a("div", {
      key: 0,
      class: "box-border overflow-auto border-1px border-primary-30 rounded-10px bg-white p-8px content-12-h16-r text-primary-80 shadow-calendar",
      style: H(o.value)
    }, [
      (r(!0), a(z, null, P(d.list, (v, m) => (r(), a("label", {
        key: m,
        class: "h-40px flex cursor-pointer rounded-5px hover:bg-light-gray",
        onClick: (u) => s(v, u)
      }, [
        i("div", {
          class: f(["flex flex-grow items-center overflow-hidden px-8px", v.key === d.modelValue ? "text-brown  bg-light-gray rounded-5px" : ""])
        }, [
          D(d.$slots, "item", { item: v }, () => [
            i("p", bt, I(v.label), 1)
          ])
        ], 2)
      ], 8, vt))), 128))
    ], 4)) : w("", !0);
  }
}), yt = { class: "relative" }, sl = /* @__PURE__ */ $({
  __name: "AuDropdownList",
  props: {
    list: {},
    maxHeight: {},
    modelValue: {},
    visible: { type: Boolean }
  },
  emits: ["update:modelValue", "update:visible"],
  setup(l, { emit: e }) {
    const t = l, o = e, s = k({
      get: () => t.modelValue,
      set: (d) => {
        o("update:modelValue", d);
      }
    }), p = k({
      get: () => t.visible,
      set: (d) => {
        o("update:visible", d);
      }
    }), c = k(() => {
      var d;
      return ((d = t.list.find((n) => n.key === t.modelValue)) == null ? void 0 : d.label) ?? "";
    });
    return (d, n) => he((r(), a("div", yt, [
      K(ee, {
        class: "w-full flex justify-left",
        "model-value": c.value,
        readonly: "",
        "right-icons": [{ iconName: d.visible ? "chevron-up" : "chevron-down" }],
        onClick: n[0] || (n[0] = (v) => o("update:visible", !d.visible))
      }, null, 8, ["model-value", "right-icons"]),
      K(ge, {
        modelValue: s.value,
        "onUpdate:modelValue": n[1] || (n[1] = (v) => s.value = v),
        visible: p.value,
        "onUpdate:visible": n[2] || (n[2] = (v) => p.value = v),
        class: "absolute z-1 w-full",
        list: d.list,
        "max-height": d.maxHeight ?? null
      }, {
        item: W((v) => [
          D(d.$slots, "item", $e(_e(v)))
        ]),
        _: 3
      }, 8, ["modelValue", "visible", "list", "max-height"])
    ])), [
      [h(xe), () => o("update:visible", !1)]
    ]);
  }
}), il = /* @__PURE__ */ $({
  __name: "AuInputSearch",
  props: {
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    leftIcon: { default: "" },
    modelValue: { default: "" },
    placeholder: { default: "" },
    rightIcon: { default: "" }
  },
  emits: ["clear", "leftIconClick", "rightIconClick", "search", "update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, o = e, s = E(!1);
    function p() {
      o("search", t.modelValue.trim());
    }
    function c(u) {
      u.key === "Enter" && !u.isComposing && !s.value && p();
    }
    function d() {
      s.value = !0;
    }
    function n() {
      window.setTimeout(() => {
        s.value = !1;
      }, 200);
    }
    const v = k(() => {
      const u = [];
      return t.rightIcon !== "" && u.push({
        iconName: t.rightIcon,
        click: () => {
          o("rightIconClick");
        }
      }), t.modelValue !== "" && u.push({
        iconName: "close",
        click: () => {
          o("update:modelValue", ""), o("clear");
        }
      }), u;
    }), m = k(() => {
      const u = t.leftIcon === "" ? "search" : t.leftIcon, _ = t.leftIcon === "" ? p : () => {
        o("leftIconClick");
      };
      return [
        {
          iconName: u,
          click: _
        }
      ];
    });
    return (u, _) => (r(), R(ee, {
      disabled: t.disabled,
      error: t.error,
      "left-icons": m.value,
      "model-value": t.modelValue,
      placeholder: t.placeholder,
      "right-icons": v.value,
      onCompositionend: n,
      onCompositionstart: d,
      onKeydown: c,
      "onUpdate:modelValue": _[0] || (_[0] = (B) => u.$emit("update:modelValue", B.toString()))
    }, null, 8, ["disabled", "error", "left-icons", "model-value", "placeholder", "right-icons"]));
  }
}), ul = /* @__PURE__ */ $({
  __name: "AuInputText",
  props: {
    assistiveText: { default: "" },
    checkboxValue: { type: [Boolean, null], default: null },
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    id: { default: () => ne() },
    label: { default: "" },
    linkDescribe: { default: "" },
    linkPath: { default: "" },
    modelValue: {},
    noLinkUnderline: { type: Boolean, default: !1 },
    placeholder: { default: "" },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:checkboxValue", "update:modelValue"],
  setup(l) {
    const e = l, t = Ve(), o = k(() => {
      const s = [];
      return e.error ? s.push({
        iconName: "exclamation-circle"
      }) : (t == null ? void 0 : t.slots.tooltip) !== void 0 && s.push({ iconName: "info-circle" }), s;
    });
    return (s, p) => (r(), R(ee, {
      id: e.id,
      "assistive-text": e.assistiveText,
      "checkbox-value": e.checkboxValue,
      disabled: e.disabled,
      error: e.error,
      label: e.label,
      "link-describe": e.linkDescribe,
      "link-path": e.linkPath,
      "model-value": s.modelValue,
      "no-link-underline": e.noLinkUnderline,
      placeholder: e.placeholder,
      readonly: e.readonly,
      required: e.required,
      "right-icons": o.value,
      "onUpdate:checkboxValue": p[0] || (p[0] = (c) => s.$emit("update:checkboxValue", c)),
      "onUpdate:modelValue": p[1] || (p[1] = (c) => s.$emit("update:modelValue", c.toString()))
    }, ve({ _: 2 }, [
      s.$slots.tooltip ? {
        name: "tooltip",
        fn: W(() => [
          D(s.$slots, "tooltip")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "assistive-text", "checkbox-value", "disabled", "error", "label", "link-describe", "link-path", "model-value", "no-link-underline", "placeholder", "readonly", "required", "right-icons"]));
  }
}), xt = ["tw", "jp", "th", "en", "fr", "de", "es", "kr"];
function gt(l) {
  return typeof l == "string" && xt.includes(l);
}
const kt = { class: "relative w-fit flex cursor-pointer" }, dl = /* @__PURE__ */ $({
  __name: "AuLanguageDropdown",
  props: {
    languages: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, o = e, s = E(!1);
    function p(n) {
      s.value = !1, o("update:modelValue", n);
    }
    const c = {
      en: "English",
      tw: "繁體中文",
      jp: "にほんご",
      th: "แบบไทย",
      fr: "le français",
      de: "Немецкий",
      es: "español",
      kr: "한국어"
    }, d = k(() => (t.languages ?? Object.keys(c)).filter(gt).map((n) => ({
      label: c[n],
      key: n
    })));
    return (n, v) => he((r(), a("div", kt, [
      i("div", {
        class: "h-24px w-48px",
        onClick: v[0] || (v[0] = (m) => s.value = !s.value)
      }, [
        i("i", {
          class: f(["text-24px", `icon-global-${n.modelValue}`])
        }, null, 2),
        i("i", {
          class: f(["text-24px", {
            "icon-chevron-down": !s.value,
            "icon-chevron-up": s.value
          }])
        }, null, 2)
      ]),
      K(ge, {
        visible: s.value,
        "onUpdate:visible": v[1] || (v[1] = (m) => s.value = m),
        class: "absolute right-0 top-24px z-1 w-fit",
        list: d.value,
        "model-value": n.modelValue,
        "onUpdate:modelValue": p
      }, null, 8, ["visible", "list", "model-value"])
    ])), [
      [h(xe), () => s.value = !1]
    ]);
  }
}), re = {
  "phone-case": {
    checked: "backplate",
    unchecked: "backplate-off"
  },
  "airpods-case": {
    checked: "airpods",
    unchecked: "airpods-off"
  },
  grip: {
    checked: "grip",
    unchecked: "grip-off"
  },
  "ipad-case": {
    checked: "ipad",
    unchecked: "ipad-off"
  },
  "airtag-case": {
    checked: "airtag",
    unchecked: "airtag-off"
  },
  aquastand: {
    checked: "aquastand",
    unchecked: "aquastand-off"
  }
};
function cl(l) {
  const e = Object.keys(re);
  return typeof l == "string" && e.includes(l);
}
const wt = { class: "relative inline-block h-32px w-64px cursor-pointer" }, $t = ["checked"], _t = /* @__PURE__ */ $({
  __name: "AuToggleSwitch",
  props: {
    checkedIcon: { default: "" },
    modelValue: { type: Boolean },
    uncheckedIcon: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(l) {
    const e = l, t = k(() => e.modelValue && e.checkedIcon !== "" ? `icon-${e.checkedIcon}` : !e.modelValue && e.uncheckedIcon !== "" ? `icon-${e.uncheckedIcon}` : "");
    return (o, s) => (r(), a("label", wt, [
      i("input", {
        checked: o.modelValue,
        class: "h-0 w-0 opacity-0",
        type: "checkbox",
        onInput: s[0] || (s[0] = (p) => o.$emit("update:modelValue", !o.modelValue))
      }, null, 40, $t),
      i("span", {
        class: f(["absolute inset-0 rounded-30px shadow-inner duration-400", {
          "bg-primary-30": o.modelValue,
          "bg-light-gray": !o.modelValue
        }])
      }, null, 2),
      i("span", {
        class: f(["absolute inset-0 h-32px w-32px flex items-center justify-center rounded-full bg-white text-24px shadow-btn-card duration-400", [
          {
            "translate-x-32px text-primary-70": o.modelValue,
            "text-primary-80": !o.modelValue
          },
          t.value
        ]])
      }, null, 2)
    ]));
  }
}), pl = /* @__PURE__ */ $({
  __name: "AuProductToggleSwitch",
  props: {
    modelValue: { type: Boolean },
    productNavigation: {}
  },
  emits: ["update:modelValue"],
  setup(l) {
    return (e, t) => (r(), R(_t, {
      "checked-icon": h(re)[e.productNavigation].checked,
      "model-value": e.modelValue,
      "unchecked-icon": h(re)[e.productNavigation].unchecked,
      "onUpdate:modelValue": t[0] || (t[0] = (o) => e.$emit("update:modelValue", o))
    }, null, 8, ["checked-icon", "model-value", "unchecked-icon"]));
  }
}), Vt = { class: "h-6px flex items-center" }, Tt = ["value"], At = /* @__PURE__ */ $({
  __name: "AuProgress",
  props: {
    progressPercentage: {}
  },
  setup(l) {
    return (e, t) => (r(), a("label", Vt, [
      i("progress", {
        max: "100",
        value: e.progressPercentage
      }, null, 8, Tt)
    ]));
  }
}), fl = /* @__PURE__ */ J(At, [["__scopeId", "data-v-d7a2aed4"]]), Ct = {
  key: 1,
  class: "text-red"
}, It = /* @__PURE__ */ $({
  __name: "CheckBoxAndRadioBase",
  props: {
    disabled: { type: Boolean },
    error: { type: Boolean },
    fontType: {},
    multiLine: { type: Boolean },
    required: { type: Boolean }
  },
  setup(l) {
    return (e, t) => (r(), a("label", {
      class: f(["flex items-center justify-between gap-8px p-4px content-12-h16-r", [
        {
          "cursor-pointer": !e.disabled,
          "opacity-30": e.disabled
        },
        e.$attrs.class
      ]])
    }, [
      i("div", {
        class: f(["flex items-center gap-4px", {
          truncate: !e.multiLine
        }])
      }, [
        D(e.$slots, "input"),
        e.$slots.default ? (r(), a("div", {
          key: 0,
          class: f(["gap-8px pl-8px", {
            "text-red": e.error,
            "peer-hover:text-primary-50": !e.disabled && !e.error,
            "text-primary-80": !e.error,
            "content-12-h16-r": e.fontType === "text",
            "title-12-h16-m": e.fontType === "title",
            "flex-shrink truncate": !e.multiLine
          }])
        }, [
          D(e.$slots, "default")
        ], 2)) : w("", !0),
        e.required ? (r(), a("span", Ct, "*")) : w("", !0)
      ], 2),
      e.$slots.description ? (r(), a("div", {
        key: 0,
        class: f(["max-w-1/2 content-10-h12-r", {
          "text-red": e.error,
          "text-primary-40": !e.error,
          truncate: !e.multiLine
        }])
      }, [
        D(e.$slots, "description")
      ], 2)) : w("", !0)
    ], 2));
  }
}), Bt = ["disabled", "required"], Lt = {
  key: 0,
  class: "box-border border-5px rounded-full border-solid",
  style: { "border-color": "inherit" }
}, ml = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "AuRadio",
  props: {
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    fontType: { default: "text" },
    modelValue: {},
    multiLine: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    value: {}
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, o = e, s = k(() => t.modelValue === t.value);
    return (p, c) => (r(), R(It, {
      class: f(p.$attrs.class),
      disabled: t.disabled,
      error: t.error,
      "font-type": t.fontType,
      "multi-line": t.multiLine,
      required: t.required
    }, ve({
      input: W(() => [
        i("input", G(h(Z)(p.$attrs), {
          class: "peer hidden select-none",
          disabled: t.disabled,
          required: t.required,
          type: "radio",
          onClick: c[0] || (c[0] = (d) => o("update:modelValue", t.value))
        }), null, 16, Bt),
        i("div", {
          class: f(["box-border h-16px w-16px flex flex-shrink-0 items-center justify-center border-1px rounded-full border-solid bg-white", {
            "border-primary-80": !t.error,
            "peer-hover:border-primary-50": !t.error && !t.disabled,
            "border-red": t.error
          }])
        }, [
          s.value ? (r(), a("div", Lt)) : w("", !0)
        ], 2)
      ]),
      _: 2
    }, [
      p.$slots.default ? {
        name: "default",
        fn: W(() => [
          D(p.$slots, "default")
        ]),
        key: "0"
      } : void 0,
      p.$slots.description ? {
        name: "description",
        fn: W(() => [
          D(p.$slots, "description")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["class", "disabled", "error", "font-type", "multi-line", "required"]));
  }
}), St = ["onClick"], Et = { class: "my-0 truncate title-14-h16-m" }, Mt = {
  key: 0,
  class: "h-16px w-16px flex flex-shrink-0 items-center justify-center rounded-full bg-brand-blush-pink title-12-h16-m text-white tracking-0"
}, hl = /* @__PURE__ */ $({
  __name: "AuTabSelector",
  props: {
    alignment: { default: "left" },
    isMobile: { type: Boolean, default: !1 },
    modelValue: {},
    tabOptions: {}
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, o = e, s = k(() => t.isMobile && t.tabOptions.length <= 3 && p.value !== null ? `${p.value.clientWidth / t.tabOptions.length}px` : ""), p = U("componentElement"), c = U("tabSelectorElement"), d = U("tabItemElements"), n = E([]), v = k(() => {
      const b = [0];
      let x = 0;
      for (const T of n.value)
        x += T, b.push(x);
      return b;
    });
    ae(() => {
      u(), j(), m(), O();
    }), fe(
      () => t.modelValue,
      () => {
        u(), O();
      }
    );
    function m() {
      const b = [];
      for (const x of d.value ?? [])
        b.push(x.clientWidth);
      n.value = b;
    }
    function u() {
      if (_.value === -1) {
        const b = t.tabOptions.find((x) => x.disabled === void 0 || !x.disabled);
        b !== void 0 && o("update:modelValue", b.key);
      }
    }
    const _ = k(
      () => t.tabOptions.findIndex(
        (b) => b.key === t.modelValue && (b.disabled === void 0 || !b.disabled)
      )
    );
    function B() {
      if (c.value === null)
        return;
      const b = c.value.scrollLeft, T = [...v.value].find((M) => M > b);
      T !== void 0 && c.value.scrollTo({ behavior: "smooth", left: T });
    }
    function L() {
      if (c.value === null)
        return;
      const b = c.value.scrollLeft, T = [...v.value].reverse().find((M) => M < b);
      T !== void 0 && c.value.scrollTo({ behavior: "smooth", left: T });
    }
    const V = E(!1), S = E(!1);
    function j() {
      if (c.value === null)
        return;
      const { scrollWidth: b, clientWidth: x, scrollLeft: T } = c.value;
      V.value = T > 0, S.value = b - x - 0.5 > T;
    }
    function O() {
      if (c.value === null) return;
      const b = v.value[_.value];
      b !== void 0 && c.value.scrollTo({
        behavior: "smooth",
        left: b
      });
    }
    return (b, x) => (r(), a("div", {
      ref_key: "componentElement",
      ref: p,
      class: "relative h-40px flex flex-shrink-0"
    }, [
      x[3] || (x[3] = i("div", { class: "absolute bottom-0 h-2px w-full bg-primary-20" }, null, -1)),
      i("div", {
        ref_key: "tabSelectorElement",
        ref: c,
        class: f(["scrollbar-hide h-full w-full flex snap-x snap-mandatory items-center overflow-x-auto", {
          "justify-center": b.alignment === "center",
          "mx-12px": t.isMobile,
          "mx-16px": !t.isMobile
        }]),
        onScroll: x[0] || (x[0] = (T) => j())
      }, [
        (r(!0), a(z, null, P(b.tabOptions, ({ title: T, key: M, disabled: q, count: X }, le) => (r(), a("div", {
          key: le,
          ref_for: !0,
          ref_key: "tabItemElements",
          ref: d,
          class: f(["relative h-full min-w-120px flex flex-shrink-0 cursor-pointer snap-start items-center justify-center", {
            "hover:bg-light-gray": M !== b.modelValue,
            "pointer-events-none": q,
            "w-240px": !b.isMobile,
            "max-w-160px": b.isMobile
          }]),
          style: H({ width: s.value }),
          onClick: () => {
            b.$emit("update:modelValue", M);
          }
        }, [
          i("div", {
            class: f(["peer box-border h-full w-full flex items-center justify-center gap-8px px-24px", {
              "text-primary-80 hover:text-primary-60": !q,
              "text-primary-30": q
            }])
          }, [
            i("p", Et, I(T), 1),
            typeof X == "number" ? (r(), a("div", Mt, I(X), 1)) : w("", !0)
          ], 2),
          i("div", {
            class: f(["pointer-events-none absolute bottom-0 h-2px w-full", {
              "peer-hover:bg-primary-40": M !== b.modelValue && !q,
              "bg-brand-deep-yellow": M === b.modelValue && !q
            }])
          }, null, 2)
        ], 14, St))), 128))
      ], 34),
      V.value ? (r(), a("div", {
        key: 0,
        class: "absolute left-0 top-0 h-full w-24px flex cursor-pointer items-center justify-center from-white via-white to-transparent bg-gradient-to-r",
        onClick: L
      }, x[1] || (x[1] = [
        i("i", { class: "icon-chevron-left text-16px text-primary-80" }, null, -1)
      ]))) : w("", !0),
      S.value ? (r(), a("div", {
        key: 1,
        class: "absolute right-0 top-0 h-full w-24px flex cursor-pointer items-center justify-center from-white via-white to-transparent bg-gradient-to-l",
        onClick: B
      }, x[2] || (x[2] = [
        i("i", { class: "icon-chevron-right text-16px text-primary-80" }, null, -1)
      ]))) : w("", !0)
    ], 512));
  }
}), Dt = { class: "flex gap-4px content-11-h16-r" }, jt = { class: "truncate text-primary-80" }, qt = {
  key: 0,
  class: "text-red"
}, Nt = ["disabled", "placeholder", "required", "value"], vl = /* @__PURE__ */ $({
  name: "AuTextarea",
  inheritAttrs: !1,
  __name: "AuTextarea",
  props: {
    assistiveText: { default: "" },
    autoResizeHeight: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    label: { default: "" },
    modelValue: {},
    placeholder: { default: "" },
    required: { type: Boolean, default: !1 },
    resize: { default: "auto" },
    textareaHeight: { default: 0 }
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = Te(), o = l, {
      modelValue: s,
      label: p,
      textareaHeight: c,
      autoResizeHeight: d,
      resize: n,
      required: v,
      disabled: m,
      error: u,
      assistiveText: _,
      placeholder: B
    } = me(o), L = e, V = E(null);
    function S(x) {
      if (!(x.target instanceof HTMLTextAreaElement))
        throw new Error("only accept HTMLTextAreaElement");
      L("update:modelValue", x.target.value), O();
    }
    const j = U("textareaElement");
    function O() {
      if (!(j.value instanceof HTMLTextAreaElement))
        return;
      if (!d.value) {
        V.value = j.value.offsetHeight;
        return;
      }
      const x = j.value.scrollHeight + 2, T = j.value.offsetHeight;
      V.value = Math.max(x, T);
    }
    ae(() => {
      c.value !== 0 && (V.value = c.value), O();
    });
    const b = k(() => m.value ? "bg-primary-10" : u.value ? "border-red" : "border-primary-30 focus:border-primary-50");
    return (x, T) => (r(), a("label", {
      class: f(["flex flex-col gap-4px", h(t).class])
    }, [
      i("span", Dt, [
        i("span", jt, I(h(p)), 1),
        h(v) ? (r(), a("span", qt, "*")) : w("", !0)
      ]),
      i("textarea", G({
        ref_key: "textareaElement",
        ref: j
      }, h(Z)(h(t)), {
        class: ["box-border h-full w-full border-1px rounded-10px px-16px py-8px content-12-h24-r text-primary-80 outline-none placeholder-primary-50", b.value],
        disabled: h(m),
        placeholder: h(B),
        required: h(v),
        style: {
          height: V.value === null ? "" : `${V.value}px`,
          resize: h(n)
        },
        value: h(s),
        onInput: S
      }), null, 16, Nt),
      h(_) !== "" ? (r(), a("span", {
        key: 0,
        class: f(["mx-16px truncate content-10-h12-r text-primary-40", {
          "text-red": h(u) && !h(m)
        }])
      }, I(h(_)), 3)) : w("", !0)
    ], 2));
  }
}), zt = { class: "relative inline-block h-32px w-fit cursor-pointer" }, Pt = ["checked", "disabled"], Ht = { class: "flex select-none items-center justify-center rounded-30px bg-green-transparent-10 px-2px py-4px content-14-h24-r text-primary-60 shadow-inner duration-400 peer-disabled:cursor-default peer-disabled:bg-green-60-5 peer-disabled:text-primary-40" }, bl = /* @__PURE__ */ $({
  __name: "AuTextToggleSwitch",
  props: {
    checkedText: {},
    disabled: { type: Boolean, default: !1 },
    modelValue: { type: Boolean },
    uncheckedText: {}
  },
  emits: ["update:modelValue"],
  setup(l) {
    const e = U("unCheckedElement"), t = U("checkedElement"), o = E(0), s = E(0), p = E();
    ae(() => {
      p.value = new ResizeObserver((d) => {
        for (const n of d) {
          const v = n.target.getBoundingClientRect();
          n.target === e.value ? o.value = v.width : n.target === t.value && (s.value = v.width);
        }
      }), e.value !== null && p.value.observe(e.value), t.value !== null && p.value.observe(t.value);
    }), Ae(() => {
      var d;
      (d = p.value) == null || d.disconnect();
    });
    const c = l;
    return (d, n) => (r(), a("label", zt, [
      i("input", {
        checked: d.modelValue,
        class: "peer absolute h-0 w-0 opacity-0",
        disabled: c.disabled,
        type: "checkbox",
        onInput: n[0] || (n[0] = (v) => d.$emit("update:modelValue", !d.modelValue))
      }, null, 40, Pt),
      i("span", Ht, [
        i("span", {
          ref_key: "unCheckedElement",
          ref: e,
          class: "relative z-1 px-12px"
        }, I(d.uncheckedText), 513),
        i("span", {
          ref_key: "checkedElement",
          ref: t,
          class: "relative z-1 px-12px"
        }, I(d.checkedText), 513)
      ]),
      i("span", {
        class: "absolute inset-2px h-28px flex items-center justify-center rounded-full bg-white shadow-btn-card duration-400",
        style: H({
          transform: d.modelValue ? `translateX(${o.value}px)` : "",
          width: d.modelValue ? `${s.value}px` : `${o.value}px`
        })
      }, null, 4)
    ]));
  }
}), Ot = 3e3, ke = Symbol("injectToast"), yl = {
  /*
    import { AuToastPlugin } from '@evolutivelabs/amuse-ui'
    app.use(AuToastPlugin)
  */
  install: (l) => {
    l.provide(ke, { addToast: Ut, removeAllToast: Wt });
  }
}, te = E(/* @__PURE__ */ new Map());
function xl() {
  const l = Ce(ke);
  if (l === void 0)
    throw new Error("toast error");
  return l;
}
function Ut(l) {
  const e = ne();
  te.value.set(e, l), Rt(e, l);
}
function Rt(l, e) {
  window.setTimeout(() => {
    te.value.delete(l);
  }, e.time ?? Ot);
}
function Wt() {
  te.value.clear();
}
const Yt = { class: "shadow-dropdown w-240px flex items-center justify-center rounded-100px bg-primary-100 px-40px md:max-w-560px md:min-w-360px md:w-auto" }, Ft = { class: "my-8px content-14-h24-r text-white" }, Kt = 150, Gt = 10, gl = /* @__PURE__ */ $({
  __name: "AuToast",
  setup(l) {
    const e = U("toastElements"), t = k(() => e.value === null || e.value.length === 0 ? [0] : e.value.map((s) => s.clientHeight));
    function o(s) {
      return t.value.slice(0, s).reduce((p, c) => p + c, 0) + s * Gt;
    }
    return (s, p) => (r(), R(Ie, {
      "enter-active-class": "ease-in-out duration-200",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: W(() => [
        (r(!0), a(z, null, P(h(te).entries(), ([c, d], n) => (r(), a("div", {
          key: c,
          ref_for: !0,
          ref_key: "toastElements",
          ref: e,
          class: "fixed left-1/2 z-50 transform duration-300 -translate-x-1/2",
          style: H({ top: `${o(n) + Kt}px` })
        }, [
          i("div", Yt, [
            i("p", Ft, I(d.content), 1)
          ])
        ], 4))), 128))
      ]),
      _: 1
    }));
  }
});
export {
  ll as AuBadge,
  ol as AuButton,
  rl as AuCalendar,
  We as AuCheckbox,
  al as AuColorDisplay,
  nl as AuColorPicker,
  sl as AuDropdownList,
  ee as AuInput,
  il as AuInputSearch,
  ul as AuInputText,
  dl as AuLanguageDropdown,
  ge as AuList,
  pl as AuProductToggleSwitch,
  fl as AuProgress,
  ml as AuRadio,
  ht as AuRoundImage,
  hl as AuTabSelector,
  bl as AuTextToggleSwitch,
  vl as AuTextarea,
  gl as AuToast,
  yl as AuToastPlugin,
  _t as AuToggleSwitch,
  qe as LoadingSpinner,
  cl as isAuProductToggleSwitchKey,
  ye as isCustomizedColor,
  ce as isImageUrl,
  gt as isLanguageKey,
  be as isNativeColor,
  xt as languageKeys,
  xl as useToast,
  xe as vClickOutside
};
//# sourceMappingURL=index.js.map
